// import logo from './logo.svg';
import { useEffect, useState } from 'react';
import { getNotificationAPI, getUserApi } from './apis';
import './App.css';
import MainRouter from './MainRouter/MainRouter';
import { AppContext } from './appContext';
import { useNavigate } from 'react-router-dom';
import { logoutOnJwtExpire } from './utils/helperFunctions';
import OneSignal from 'react-onesignal';
import NoInternetPage from './components/NoInternet/NoInternetPage';

function App() {
  console.log('API URL:', process.env.REACT_APP_ENVIRONMENT);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token')); // Assuming you stored the token in localStorage
  const [tokenExpiration, setTokenExpiration] = useState(null);
  const [chatCount, setChatCount] = useState(null);
  const [weavychatcount, setweavychatcount] = useState(0);
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    setLoggedInUser(null);
    navigate('/sign-in');
  };

  const clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  };

  const fetchUserProfile = async () => {
    try {
      const res = await getUserApi();
      if (res.status === 200) {
        // console.log(res.data)
        setLoggedInUser({ data: res.data.Profile });
      }
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        logoutOnJwtExpire();
        navigate('/sign-in');
      }
      else if(error?.response?.data?.error==='User does not exist'){
        logoutOnJwtExpire();
        navigate('/sign-in');
      }
    }
  };

  useEffect(() => {
    if (Boolean(localStorage.getItem('token'))) {
      setIsLoggedIn(true);
    }
    clearCacheData();
  }, []);
   useEffect(() => {
    getnotificaitondata()
  }, [loggedInUser, weavychatcount, chatCount]);

  const getnotificaitondata = async () => {
    try {
      if (loggedInUser) {
        const resdata = await getNotificationAPI(loggedInUser?.data?.hospitalProfile?._id, undefined);
        console.log(resdata?.data?.hospitalNotification?.unReadNotification?.length);
        console.log(weavychatcount)
        const count = resdata?.data?.hospitalNotification?.unReadNotification?.length;
        var weavychatcountF = weavychatcount ? weavychatcount : 0;
        var total = Number(weavychatcountF) + Number(count);
        setChatCount(total)
        console.log("notificatino count of the device", total)
      }

    } catch (error) {
      console.log("app js err", error)
    }

  }
  useEffect(()=>{
    OneSignal.init({ appId: process.env.REACT_APP_ONESIGNAL_APP_ID ,allowLocalhostAsSecureOrigin: true, }).then(() => {
      OneSignal.Slidedown.promptPush();
    // do other stuff
    });
  },[]);
  useEffect(() => {
    if (isLoggedIn) {
      fetchUserProfile();
      setToken(localStorage.getItem('token'));
    }
  }, [isLoggedIn]);
  
  useEffect(() => {
    if (token) {
      const tokenData = JSON.parse(atob(token.split('.')[1]));
      const tokenExpirationTime = new Date(tokenData.exp * 1000);
      setTokenExpiration(tokenExpirationTime);
      const timer = setInterval(() => {
        const currentTime = new Date();
        if (currentTime > tokenExpirationTime) {
          clearInterval(timer);
          localStorage.removeItem('token');
          setIsLoggedIn(false);
          setLoggedInUser(null);
          navigate('/sign-in');
        }
      }, 1000);
      return () => {
        clearInterval(timer);
      };
    }
  }, [token]);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
 useEffect(() => {
    function handleOnline() {
      setIsOnline(true);
    }
    function handleOffline() {
      setIsOnline(false);
    }
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  const retryConnection = () => {
  if (navigator.onLine) {
    setIsOnline(true);
  }
};

  if (!isOnline) {
    // If offline, render NoInternet component only
    return <NoInternetPage onRetry={retryConnection} />;
  }
  return (
    // <BrowserRouter>
    <AppContext.Provider
      value={{
        state: {
          isLoggedIn,
          loggedInUser,
        },
        loggedInUser,
        setIsLoggedIn,
        fetchUserProfile,
        logout,
        chatCount,
        setChatCount,
        weavychatcount,
        setweavychatcount,
        getnotificaitondata
      }}>
      <MainRouter />
    </AppContext.Provider>
    // </BrowserRouter>
  );
}

export default App;
